module.exports = __webpack_public_path__ + "c27942cee649d7735d0ca3c02364d5d5.fbx";